"use client";

interface Props {
  anchors: number[];        // SVG x positions, one per data point
  viewBoxWidth: number;
  plotTop: number;          // top Y of plot area in SVG coords
  plotBottom: number;       // bottom Y of plot area in SVG coords
  onActivate: (index: number, pointerType: string) => void;
  onLeave: () => void;
  onTap: (index: number, pointerType: string) => void;
}

/**
 * Invisible rects covering each "slice" of the chart so pointermove anywhere
 * in that slice activates that data point. Slice boundaries are the midpoints
 * between adjacent anchors (or the chart edge for the first/last slice).
 */
export function HoverHitAreas({ anchors, viewBoxWidth, plotTop, plotBottom, onActivate, onLeave, onTap }: Props) {
  if (anchors.length === 0) return null;
  const plotHeight = plotBottom - plotTop;

  return (
    <g aria-hidden="true">
      {anchors.map((anchor, i) => {
        const leftEdge = i === 0 ? 0 : (anchors[i - 1] + anchor) / 2;
        const rightEdge = i === anchors.length - 1 ? viewBoxWidth : (anchor + anchors[i + 1]) / 2;
        return (
          <rect
            key={i}
            data-testid="hover-hit-area"
            x={leftEdge}
            y={plotTop}
            width={rightEdge - leftEdge}
            height={plotHeight}
            fill="transparent"
            onPointerMove={(e) => onActivate(i, e.pointerType)}
            onPointerEnter={(e) => onActivate(i, e.pointerType)}
            onPointerLeave={onLeave}
            onPointerUp={(e) => onTap(i, e.pointerType)}
            style={{ cursor: "crosshair" }}
          />
        );
      })}
    </g>
  );
}
